import { useTrans } from "~/hooks/useTrans";
import { FOOTER_LINKS } from "~/const";
import ExternalLink from "~/components/ExternalLink";

import "./style.less";

interface IFooter {
	hideLinks?: boolean;
}

export default function Footer({
	hideLinks = true,
}: IFooter) {
	const { trans } = useTrans();

	return <div className="footer">
		{ !hideLinks && <p className="footer__links">
			<ExternalLink to={FOOTER_LINKS.SEZNAM}>{ trans("footer.seznam") }</ExternalLink>
			<ExternalLink to={FOOTER_LINKS.HELP}>{ trans("footer.help") }</ExternalLink>
			<ExternalLink to={FOOTER_LINKS.RULES}>{ trans("footer.rules") }</ExternalLink>
			<ExternalLink to={FOOTER_LINKS.CONTACT}>{ trans("footer.contact") }</ExternalLink>
		</p> }
		<p className="footer__copyright">
			{ trans("footer.copyright", { year: new Date().getFullYear() }) }
		</p>
	</div>;
}
